export default {
  setDisplayName (state, displayName) {
    state.displayName = displayName
  },
  setPhotoURL (state, photoURL) {
    state.photoURL = photoURL
  },
  setUnsavedData (state, flag) {
    state.unsavedData = flag
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js